import Api from '../Api';

import { url } from './config';
import { Flight } from './trash/model';

class ExtendedApi extends Api<Flight> {}

const api = new ExtendedApi(url);

export default api;
